<template>
  <CollapseFilters ref="collapse">
    <Form ref="form" @submit.prevent>
      <div class="row g-4">
        <div class="col-lg-3 col-md-6">
          <label class="form-label">{{ $t("dataInicialDeExpiracao") }}</label>
          <DateInput v-model="filters.closingInitialDate" />
        </div>
        <div class="col-lg-3 col-md-6">
          <label class="form-label">{{ $t("dataFinalDeExpiracao") }}</label>
          <DateInput v-model="filters.closingEndDate" :required="filters.closingInitialDate !== ''" />
        </div>
        <div class="col-lg-6 col-md-6">
          <label class="form-label">{{ $t("pesquisar") }}</label>
          <input v-model="filters.search" type="text" class="form-control" maxlength="64">
        </div>
        <div class="col-lg-4 col-md-6">
          <label class="form-label">{{ $t("status") }}</label>
          <ReceitasStatusDropdown v-model="filters.status" />
        </div>
      </div>
      <div class="d-grid gap-2 d-md-flex justify-content-md-end mt-4">
        <LoadingButton class="btn-primary" :loading="loading" @click="onClick">
          <i class="bi bi-filter" /> {{ $t("filtrar") }}
        </LoadingButton>
      </div>
    </Form>
  </CollapseFilters>
</template>

<script>
import CollapseFilters from '@/modules/shared/components/CollapseFilters.vue';
import Form from '@/modules/core/components/FormInput.vue';
import DateInput from '@/modules/core/components/DateInput.vue';
import LoadingButton from '@/modules/core/components/LoadingButton.vue';
import { useToast } from 'vue-toastification';
import { i18n } from '@/modules/localization';
import { ref, computed } from 'vue';
import ReceitasStatusDropdown from '@/modules/admin/receitas/components/ReceitasStatusDropdown.vue';

export default {
  components: { CollapseFilters, Form, DateInput, LoadingButton, ReceitasStatusDropdown },
  props: {
    loading: { type: Boolean, required: true },
  },
  emits: ['filter'],
  data: () => ({
    filters: {
      closingInitialDate: '',
      closingEndDate: '',
      search: '',
      status: [0, 1],
    },
  }),
  mounted() { this.$emit('filter', this.filters); },
  methods: {
    onClick() {
      if (this.validateDate()) {
        if (this.$refs.form.validate()) {
          this.$emit('filter', this.filters);
          this.$refs.collapse.toggle();
        }
      }
    },
    validateDate() {
      if (this.filters.closingInitialDate !== '') {
        if (new Date(this.filters.closingInitialDate) > new Date(this.filters.closingEndDate)) {
          useToast().error(ref(computed((_) => i18n.global.t('dataInicialExpiracaoSuperiorAFinal'))));
          return false;
        }
      }
      if (this.filters.creationInitialDate !== '') {
        if (new Date(this.filters.creationInitialDate) > new Date(this.filters.creationEndDate)) {
          useToast().error(ref(computed((_) => i18n.global.t('dataInicialCompraSuperiorAFinal'))));
          return false;
        }
      }
      return true;
    },
  },
};

</script>
